import { render, staticRenderFns } from "./AppointmentsLayout.vue?vue&type=template&id=3f4737f4&scoped=true"
import script from "./AppointmentsLayout.vue?vue&type=script&lang=js"
export * from "./AppointmentsLayout.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsLayout.vue?vue&type=style&index=0&id=3f4737f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4737f4",
  null
  
)

export default component.exports